<template>
	<div class="auth-container">
		<div class="auth-form">
			<div class="form-group">
				<label class="label" for="inputLogin">Логин:</label>
				<input type="text" v-model="login" id="inputLogin" :disabled="isDisabled" />
			</div>
			<div class="form-group">
				<label class="label" for="inputPassword">Пароль:</label>
				<input type="password" v-model="passwd" id="inputPassword" :disabled="isDisabled" />
			</div>
			<div class="form-group checkbox">
				<input type="checkbox" v-model="remember" id="remember-me" :disabled="isDisabled" />
				<label for="remember-me">Запомнить меня</label>
				
			</div>
			<div  class="form-group">
				<button @click="doLogin" :disabled="isDisabled" >Войти</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			login: '',
			passwd: '',
			remember: false,
			isDisabled: false
		}
	},

	methods: {
		async doLogin() {
			//this.isDisabled = true
			await this.$store.dispatch('login', {
				login: this.login,
				passwd: this.passwd,
				remember: this.remember
			})

			//this.isDisabled = false
			this.login = ''
			this.passwd = ''
		}
	}
}
</script>

<style>
.auth-container {
	height: 100%;
	/*border: 1px solid #F00; */
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.auth-form {
	width: 80%;
	margin: 0 auto;
	border: 1px solid #69808d;

	padding: 25px;
}

.auth-form .form-group {
	padding: 10px 0;
	display: flex;
}

.auth-form .form-group.checkbox {
	justify-content: center;
}

.auth-form LABEL.label {
	display: inline-block;
	width: 20%;
	text-align: right;
	padding-right: 1em;

	align-self: center;
}

.auth-form INPUT[type="text"],
.auth-form INPUT[type="password"] {
	border: 1px solid #4f4f4f;
	color: #f2f2f2;
	background-color: #383838;
	outline: 0;

	padding: 0 5px;
    min-height: 24px;

	display: inline-block;
	flex-grow: 1;
}

.auth-form INPUT[type="checkbox"] {
	margin-right: 10px;	
	
}

.auth-form BUTTON {
	border: 2px solid #69808d;
	border-radius: 3px;
	background-color: #69808d;

	color: #F2F2F2;

	outline: 0;

	display: inline-block;
	width: 100%;
	padding: 0.51em 0;
	font-size: 110%;
}

.auth-form BUTTON:hover {
    color: #f2f2f2;
    background-color: #5e737e;
    border-color: #5e737e;
}

.form-group {

}
</style>
